var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  buildCommutativeOperatorExpression: () => buildCommutativeOperatorExpression,
  isCommutativeOperator: () => isCommutativeOperator
});
var import_mathFunctionError = __toModule(require("../../../../../error/mathFunctionError"));
var import_utils = __toModule(require("../utils"));
const COMMUTATIVE_OPERATORS_TRANSLATE = {
  add: "+",
  and: "and",
  or: "or",
  multiply: "*"
};
const NON_COMMUTATIVE_OPERATORS_TRANSLATE = {
  divide: "/",
  subtract: "-"
};
const NON_COMMUTATIVE_OPERATORS_ALTERNATE = {
  divide: COMMUTATIVE_OPERATORS_TRANSLATE.multiply,
  subtract: COMMUTATIVE_OPERATORS_TRANSLATE.add
};
const COMMUTATIVE_OPERATORS = Object.keys(COMMUTATIVE_OPERATORS_TRANSLATE);
const NON_COMMUTATIVE_OPERATORS = Object.keys(NON_COMMUTATIVE_OPERATORS_TRANSLATE);
const ALL_OPERATORS = COMMUTATIVE_OPERATORS.concat(NON_COMMUTATIVE_OPERATORS);
const isCommutativeOperator = (functionName) => {
  return ALL_OPERATORS.includes(functionName);
};
const getNonCommutativeOperandExpression = (operator, allOperands) => {
  const operandExpression = allOperands.join(` ${operator} `);
  if (allOperands.length === 1) {
    return `${operandExpression}`;
  }
  return `(${operandExpression})`;
};
const buildCommutativeOperatorExpression = (functionName, operands1, operands2) => {
  if (!isCommutativeOperator(functionName)) {
    throw new import_mathFunctionError.MathFunctionError(`Function ${functionName}. Not a commutative function`);
  }
  if (COMMUTATIVE_OPERATORS.includes(functionName)) {
    const operator2 = COMMUTATIVE_OPERATORS_TRANSLATE[functionName];
    const allOperands = (0, import_utils.concatMultipleOperands)(operands1, operands2);
    const operandExpression = allOperands.join(` ${operator2} `);
    if (allOperands.length === 1) {
      return `${operandExpression}`;
    }
    return `(${operandExpression})`;
  }
  const operator = NON_COMMUTATIVE_OPERATORS_TRANSLATE[functionName];
  const allOperands1 = (0, import_utils.concatMultipleOperands)(operands1);
  const allOperands2 = (0, import_utils.concatMultipleOperands)(operands2);
  const alternateOperator = NON_COMMUTATIVE_OPERATORS_ALTERNATE[functionName];
  const operands1Expression = getNonCommutativeOperandExpression(alternateOperator, allOperands1);
  const operands2Expression = getNonCommutativeOperandExpression(alternateOperator, allOperands2);
  if (!operands2Expression) {
    return `(${operands1Expression})`;
  }
  return `(${operands1Expression} ${operator} ${operands2Expression})`;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  buildCommutativeOperatorExpression,
  isCommutativeOperator
});
